module.exports = __webpack_public_path__ + "static/media/Serving_dish_icon.c1e573f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePage/Serving_dish_icon.jpg
// module id = 331
// module chunks = 0